module.exports = __webpack_public_path__ + "assets/img/jq_icon.4a97f279.png";